module.exports = __webpack_public_path__ + "h5/img/overlay-close.a4d1578d.png";